import { Business, Event } from 'services/@types';

export function getTopEventsByGuests(events: Event[], limit: number): Event[] {
  return [...events]
    .sort((a, b) => (b.numberOfGuests ?? 0) - (a.numberOfGuests ?? 0))
    .slice(0, limit);
}

export function getActiveBusinesses(businesses: Business[], limit: number): Business[] {
  return businesses
    .filter((b) => b.subscription?.type === 'active')
    .slice(0, limit);
}

export function formatLastSeen(date: Date | string | undefined): string {
  if (!date) return '-';
  const ms = Date.now() - new Date(date).getTime();
  const minutes = Math.floor(ms / 60000);
  if (minutes < 2) return 'Just now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days} day${days !== 1 ? 's' : ''} ago`;
}
